export default {
  brand: "Clefs de Lys SA",
  hero: {
    subtitle: "Keys, Cylinders & Repairs",
    tagline: "Keys, locksmithing, repairs... Our domain for over 25 years!",
    cta: "Get in Touch",
    operatingSince: "Operating since 2001",
  },
  nav: {
    home: "Home",
    blog: "Blog",
    partners: "Partners",
    contact: "Contact",
  },
  services: {
    badge: "Our Services",
    heading: "What We Offer",
    description: "Comprehensive locksmith and security solutions tailored to your needs",
    items: {
      keyCutting: {
        title: "Precision Key Cutting",
        description: "High-precision key duplication using state-of-the-art machinery for all major brands and custom profiles.",
      },
      cylinders: {
        title: "Cylinder Systems",
        description: "Premium cylinder locks and complete security systems for residential, commercial, and industrial applications.",
      },
      masterKey: {
        title: "Master Key Solutions",
        description: "Custom master key hierarchies designed for property managers, hotels, and large facilities.",
      },
      repair: {
        title: "Repair & Installation",
        description: "Professional lock repair, replacement, and new installation services with rapid response times.",
      },
    },
  },
  about: {
    label: "About Clefs de Lys SA",
    text: "Founded in 2001 in the heart of Switzerland, Clefs de Lys SA has grown from a small locksmith workshop into a trusted name in key cutting and security cylinder systems. We combine traditional craftsmanship with modern precision technology to serve thousands of residential and commercial clients across the region.",
    stats: {
      experience: "Years of Experience",
      keys: "Keys Cut Annually",
      satisfaction: "Client Satisfaction",
      partners: "Business Partners",
    },
  },
  trust: {
    label: "By the Numbers",
    heading: "Precision at Scale",
    text: "Over a quarter century of Swiss craftsmanship, delivered one key at a time. Here's what that looks like in numbers.",
    counters: {
      keys: {
        value: "250K+",
        label: "Keys Cut",
      },
      cylinders: {
        value: "85K+",
        label: "Cylinders Installed",
      },
      clients: {
        value: "12K+",
        label: "Happy Clients",
      },
      projects: {
        value: "3.2K+",
        label: "Security Projects",
      },
      response: {
        value: "<24h",
        label: "Response Time",
      },
    },
  },
  partners: {
    badge: "Trusted Network",
    heading: "Our Suppliers & Partners",
    description: "We work with Switzerland's most respected manufacturers and distributors to bring you the best products",
    keyPartners: "Key & Cylinder Partners",
    allPartners: "Suppliers",
    realEstate: "Real Estate Partners",
    realEstateDescription: "Trusted real estate agencies and property management firms we proudly collaborate with",
    viewAll: "View All",
    pageHeading: "All Partners & Suppliers",
    pageDescription: "Discover our complete network of trusted partners, suppliers, and collaborators across Switzerland and beyond.",
  },
  blog: {
    badge: "Latest Articles",
    heading: "Insights & Expertise",
    description: "Tips, guides, and industry news from Switzerland's trusted key and cylinder specialists.",
    readMore: "Read more",
    backToAll: "Back to all articles",
    backToBlog: "Back to Blog",
    notFoundTitle: "Article Not Found",
    notFoundText: "The article you are looking for does not exist or may have been moved.",
    relatedTitle: "Related Articles",
    helpfulTitle: "Found this article helpful?",
    helpfulText: "Share it with your team or colleagues.",
    shareX: "Share on X",
    shareLinkedIn: "Share on LinkedIn",
    copyLink: "Copy link",
  },
  cta: {
    heading: "Ready to secure what matters?",
    description: "Whether you need a single key duplicated or a complete master key system for your building, our team is here to help.",
    button: "Contact Us",
    addressLabel: "Visit Us",
    phoneLabel: "Call Us",
    emailLabel: "Email Us",
  },
  footer: {
    heading: "Stay informed",
    description: "Subscribe to our newsletter for security tips and company updates.",
    placeholder: "Your email address",
    subscribe: "Subscribe",
    success: "Thank you for subscribing!",
    error: "Something went wrong. Please try again.",
    navigation: "Navigation",
    contact: "Contact",
    address: "Address",
    addressLines: "Rue Alexandre Cailler 6, 1636 Broc, Switzerland",
    privacy: "Privacy Policy",
    legal: "Legal Notice / Impressum",
    terms: "Terms of Service",
    rights: "All rights reserved.",
  },
  contact: {
    badge: "Get in Touch",
    heading: "Contact Us",
    description: "Whether you need a key cut, a cylinder replaced, or advice on securing your property — we are here to help.",
    formTitle: "Send us a message",
    name: "Name",
    namePlaceholder: "Your name",
    email: "Email",
    emailPlaceholder: "your@email.com",
    phone: "Phone",
    phonePlaceholder: "+41 XX XXX XX XX",
    message: "Message",
    messagePlaceholder: "How can we help you?",
    photo: "Photos (optional)",
    photoHint: "Attach photos of your lock, key, or door — JPG, PNG, WebP, and more accepted",
    send: "Send Message",
    success: "Message sent successfully!",
    errorGeneric: "Something went wrong. Please try again.",
    errorNetwork: "Network error. Please check your connection and try again.",
    infoTitle: "Contact Information",
    addressLabel: "Address",
    phoneLabel: "Phone",
    emailLabel: "Email",
    hoursLabel: "Store Hours",
    getDirections: "Get Directions",
    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
    },
    closed: "Closed",
    hoursSlot: "07:30 – 12:00 / 13:30 – 17:00",
    holidaysNote: "For key services, the store is closed on public holidays, non-working days and bridge days.",
  },
  presentation: {
    heading: "Clefs de Lys SA offers several services in the following areas:",
    items: [
      "Lock repair, cylinders, keys, safes, and more",
      "Door closer installation, door stops, adjustments, replacement",
      "Anti-burglary system installation",
      "Electronic lock installation, electric strikes, and more",
      "Electrical cylinders",
      "Safe sales and installation",
      "Locking plan creation",
      "Key services",
      "Small locksmith work",
    ],
  },
  language: "Language",
  privacyPolicy: {
    title: "Privacy Policy",
    lastUpdated: "Last updated: 22.07.2026",
    sections: [
      {
        heading: "1. Data Controller",
        body: "The entity responsible for the processing of personal data in accordance with Swiss data protection legislation is:\n\nClefs de Lys SA\nRue Alexandre Cailler 6\n1636 Broc\nSwitzerland\n\nEmail: service@clefsdelys.ch\nPhone: +41 26 919 53 60",
      },
      {
        heading: "2. General Information",
        body: "Protecting your personal data is important to Clefs de Lys SA. We process personal data in accordance with the Swiss Federal Data Protection Act (FADP/LPD) and other applicable legal provisions.\n\nThis Privacy Policy explains what personal data we collect, how we use it, and what rights you have regarding your personal information.",
      },
      {
        heading: "3. Personal Data We Collect",
        body: "As part of our business activities, we may collect and process the following personal data:\n\n• First name and last name;\n• Postal address;\n• Email address;\n• Telephone number;\n• Information related to inquiries, quotations, and orders;\n• Information related to our services (keys, cylinders, locking systems, master key systems, closing plans, and locksmith services);\n• Information required for billing and administrative purposes.",
      },
      {
        heading: "4. Purpose of Data Processing",
        body: "Clefs de Lys SA processes personal data only for legitimate business purposes, including:\n\n• Handling customer requests and orders;\n• Preparing quotations and offers;\n• Providing locksmith and security services;\n• Managing customer relationships;\n• Processing invoices and accounting obligations;\n• Communicating with customers regarding our services.",
      },
      {
        heading: "5. Legal Basis for Processing",
        body: "The processing of personal data is based on:\n\n• The performance of contractual obligations or pre-contractual measures;\n• Compliance with legal obligations;\n• Our legitimate interest in providing secure and reliable services.",
      },
      {
        heading: "6. Disclosure of Personal Data to Third Parties",
        body: "Clefs de Lys SA does not sell, rent, or trade personal data.\n\nPersonal data may only be shared with third parties when necessary, including:\n\n• Suppliers or partners involved in fulfilling customer orders;\n• Technical service providers required for our IT systems and website operation;\n• Public authorities when required by law.\n\nAll third parties involved are expected to respect the confidentiality and security of personal data.",
      },
      {
        heading: "7. Confidentiality of Security Information",
        body: "Due to the nature of our activities, Clefs de Lys SA may handle confidential security-related information, including:\n\n• Master key system information;\n• Locking plans;\n• Cylinder configurations;\n• Access control information.\n\nSuch information is treated confidentially and is only processed for authorized purposes and legitimate customers.",
      },
      {
        heading: "8. Data Retention",
        body: "Clefs de Lys SA retains personal data only for as long as necessary to fulfill the purposes for which it was collected.\n\nBusiness and accounting-related information is retained according to the legal retention periods applicable in Switzerland.",
      },
      {
        heading: "9. Data Security",
        body: "We implement appropriate technical and organizational measures to protect personal data against:\n\n• Unauthorized access;\n• Loss or destruction;\n• Unauthorized modification;\n• Disclosure to unauthorized persons.",
      },
      {
        heading: "10. Cookies and Website Technologies",
        body: "Our website may use cookies and similar technologies to ensure proper website functionality and improve user experience.\n\nCookies may be used for:\n\n• Technical operation of the website;\n• Remembering user preferences;\n• Website performance analysis (only if analytics tools are implemented).\n\nYou can manage or disable cookies through your browser settings.",
      },
      {
        heading: "11. External Links",
        body: "Our website may contain links to external websites.\n\nClefs de Lys SA is not responsible for the privacy practices or content of third-party websites. We recommend reviewing the privacy policies of those websites separately.",
      },
      {
        heading: "12. Your Rights",
        body: "Under applicable data protection laws, you may have the right to:\n\n• Request information about your personal data;\n• Request correction of inaccurate data;\n• Request deletion of your personal data where legally permitted;\n• Object to certain processing activities.\n\nTo exercise your rights, please contact us using the contact details provided above.",
      },
      {
        heading: "13. Changes to This Privacy Policy",
        body: "Clefs de Lys SA reserves the right to update this Privacy Policy when necessary due to legal, technical, or organizational changes.\n\nThe latest version published on our website shall apply.",
      },
    ],
  },
  legalNotice: {
    title: "Legal Notice / Impressum",
    lastUpdated: "Last updated: 22.07.2026",
    sections: [
      {
        heading: "Company Information",
        body: "Clefs de Lys SA\nRue Alexandre-Cailler 6\n1636 Broc\nSwitzerland\n\nLegal form: Société Anonyme (SA)\n\nUID / CHE Number: CHE-109.270.807\n\nCommercial Register Number: CH-217.0.431.678-4\n\nCommercial Register Office: Canton of Fribourg, Switzerland",
      },
      {
        heading: "Contact Information",
        body: "Phone: +41 26 919 53 60\nEmail: service@clefsdelys.ch\nWebsite: www.Clefsdelys.ch",
      },
      {
        heading: "Responsible for Website Content",
        body: "The company responsible for the content published on this website is:\n\nClefs de Lys SA\nRue Alexandre-Cailler 6\n1636 Broc\nSwitzerland",
      },
      {
        heading: "Purpose of the Website",
        body: "This website provides information about Clefs de Lys SA and its services, including locksmith services, key services, cylinders, locking systems, master key systems, security solutions, and related professional services.",
      },
      {
        heading: "Intellectual Property",
        body: "All content published on this website, including texts, images, logos, graphics, documents, and other materials, is protected by applicable intellectual property laws.\n\nAny reproduction, distribution, modification, or use of website content without prior written authorization from Clefs de Lys SA is prohibited.",
      },
      {
        heading: "Disclaimer",
        body: "Clefs de Lys SA makes every effort to ensure that the information provided on this website is accurate, complete, and up to date.\n\nHowever, Clefs de Lys SA cannot guarantee that the information published on this website is always free from errors or omissions.\n\nClefs de Lys SA accepts no liability for any direct or indirect damages resulting from the use of this website or the information provided herein.",
      },
      {
        heading: "External Links",
        body: "This website may contain links to external websites operated by third parties.\n\nClefs de Lys SA has no control over the content, availability, or privacy practices of these external websites and assumes no responsibility for them.",
      },
      {
        heading: "Data Protection",
        body: "The processing of personal data collected through this website is governed by our Privacy Policy.\n\nFor further information regarding the collection, use, and protection of personal data, please refer to our Privacy Policy.",
      },
      {
        heading: "Applicable Law and Jurisdiction",
        body: "This Legal Notice is governed by Swiss law.\n\nAny disputes arising from the use of this website shall be subject to the applicable courts in Switzerland, unless mandatory legal provisions provide otherwise.",
      },
    ],
  },
  termsOfService: {
    title: "Terms of Service",
    lastUpdated: "Effective Date: July 22, 2026",
    intro: "Welcome to the website of Clefs de Lys SA. These Terms of Service (\"Terms\") govern your access to and use of our website, products, and services. By accessing this website or engaging our services, you agree to comply with these Terms. If you do not agree, please discontinue use of the website.",
    sections: [
      {
        heading: "1. About Clefs de Lys SA",
        body: "Clefs de Lys SA is a Swiss locksmith and security company providing professional solutions for residential, commercial, and industrial customers. Our services include key duplication, security cylinders, master key systems, access control solutions, door hardware, safe installations, lock repairs, emergency locksmith assistance, and related security services.",
      },
      {
        heading: "2. Acceptance of These Terms",
        body: "By using this website, requesting a quotation, placing an order, or using our services, you acknowledge that you have read, understood, and accepted these Terms of Service.",
      },
      {
        heading: "3. Website Use",
        body: "You agree to use this website responsibly and only for lawful purposes.\n\nYou may not:\n\n• interfere with the operation or security of the website;\n• attempt unauthorized access to our systems;\n• upload malicious software or harmful content;\n• misuse contact forms or communication channels;\n• reproduce or distribute website content without prior written authorization.",
      },
      {
        heading: "4. Information on the Website",
        body: "We make reasonable efforts to ensure that all information published on this website is accurate and up to date.\n\nHowever, product descriptions, specifications, availability, images, and pricing are provided for general information only and may be updated or corrected without prior notice.",
      },
      {
        heading: "5. Products and Services",
        body: "Our products and services may include:\n\n• Key cutting and duplication\n• Security cylinders\n• Mechanical and electronic locking systems\n• Master key systems\n• Access control solutions\n• Safes and secure storage products\n• Door hardware\n• Lock installation and repairs\n• Emergency locksmith services\n• Maintenance and security upgrades\n\nAvailability may vary depending on stock, suppliers, or technical requirements.",
      },
      {
        heading: "6. Quotes and Orders",
        body: "All quotations are provided without obligation unless expressly stated otherwise.\n\nAn order becomes binding only after confirmation by Clefs de Lys SA.\n\nFor certain security products, customers may be required to provide proof of ownership, identity verification, authorization cards, or additional documentation before manufacturing or delivery.\n\nWe reserve the right to decline or cancel orders that cannot be verified or that do not comply with legal or security requirements.",
      },
      {
        heading: "7. Prices and Payment",
        body: "Prices may change without prior notice until an order has been confirmed.\n\nInvoices must be paid within the payment period specified on the invoice.\n\nLate payments may result in reminder fees, statutory interest, suspension of services, or legal recovery procedures where permitted by Swiss law.",
      },
      {
        heading: "8. Delivery and Installation",
        body: "Delivery dates are estimates unless specifically confirmed in writing.\n\nClefs de Lys SA is not responsible for delays caused by suppliers, manufacturers, transport companies, customs procedures, force majeure events, or circumstances beyond our reasonable control.\n\nCustomers are responsible for ensuring safe access to installation sites.\n\nAdditional work requested during installation may result in additional charges after customer approval.",
      },
      {
        heading: "9. Emergency Services",
        body: "Emergency locksmith services are offered based on technician availability.\n\nResponse times cannot be guaranteed and depend on workload, distance, weather, traffic, and operational circumstances.\n\nAdditional charges may apply outside normal business hours.",
      },
      {
        heading: "10. Customer Responsibilities",
        body: "Customers are responsible for providing accurate and complete information when requesting products or services.\n\nThis includes, where applicable:\n\n• lock references;\n• cylinder dimensions;\n• key numbers;\n• security authorization documents;\n• installation details;\n• ownership information.\n\nIncorrect information may result in delays, additional costs, or incompatible products.",
      },
      {
        heading: "11. Warranty",
        body: "Where applicable, products are covered by the manufacturer's warranty.\n\nInstallation and repair work performed by Clefs de Lys SA is covered against workmanship defects in accordance with applicable Swiss law or any written warranty provided.\n\nThe warranty does not cover damage resulting from misuse, unauthorized modifications, accidents, normal wear, improper maintenance, or third-party intervention.",
      },
      {
        heading: "12. Limitation of Liability",
        body: "To the fullest extent permitted by applicable law, Clefs de Lys SA shall not be liable for indirect, incidental, consequential, or economic damages arising from the use of this website, products, or services.\n\nNothing in these Terms limits liability where such limitation is prohibited by mandatory Swiss law.",
      },
      {
        heading: "13. Intellectual Property",
        body: "All content available on this website — including text, graphics, logos, icons, images, documents, layouts, and software — is the property of Clefs de Lys SA or its licensors and is protected by intellectual property laws.\n\nNo content may be copied, reproduced, distributed, or modified without prior written permission.",
      },
      {
        heading: "14. Privacy",
        body: "Your use of this website is also governed by our Privacy Policy.\n\nPersonal information is processed only for legitimate business purposes and in accordance with applicable Swiss data protection legislation.",
      },
      {
        heading: "15. Third-Party Websites",
        body: "This website may contain links to external websites for your convenience.\n\nClefs de Lys SA is not responsible for the availability, content, security, or privacy practices of third-party websites.",
      },
      {
        heading: "16. Service Availability",
        body: "We strive to maintain continuous access to our website and online services.\n\nHowever, we do not guarantee uninterrupted availability and reserve the right to suspend or modify services for maintenance, security updates, technical improvements, or unforeseen circumstances.",
      },
      {
        heading: "17. Force Majeure",
        body: "Clefs de Lys SA shall not be liable for delays or failure to perform its obligations resulting from events beyond its reasonable control, including natural disasters, strikes, supplier disruptions, cyber incidents, governmental measures, or other force majeure events.",
      },
      {
        heading: "18. Changes to These Terms",
        body: "We may update these Terms of Service from time to time.\n\nThe latest version will always be published on this website with the updated effective date.\n\nContinued use of the website after publication constitutes acceptance of the revised Terms.",
      },
      {
        heading: "19. Governing Law",
        body: "These Terms of Service are governed by the laws of Switzerland.\n\nAny dispute arising from these Terms or the use of our services shall be subject to the jurisdiction of the competent courts of the Canton of Fribourg, unless mandatory law provides otherwise.",
      },
      {
        heading: "20. Contact",
        body: "If you have any questions regarding these Terms of Service or any of our services, please contact Clefs de Lys SA using the contact information available on this website.",
      },
    ],
  },
};